import extendSchema from "@api/helpers/extendSchema";

import type { AddressInput } from "./types";

const DWOLLA_STREET_MAX_LENGTH = 100;

const getDwollaAddressSchema = (addressSchema: AddressInput[]): AddressInput[] => {
  const newInputs = extendSchema(addressSchema, [
    {
      name: "streetAddress",
      maxLength: DWOLLA_STREET_MAX_LENGTH,
    },
  ]);

  return newInputs;
};

export default getDwollaAddressSchema;
